export const gridDesktop = [
	{
		id: 1,
		image: require("./images/desktop/image-gallery-milkbottles.jpg"),
		name:"milk bottles"
	},
	{
		id: 2,
		image: require("./images/desktop/image-gallery-orange.jpg"),
		name:"orange"
	},
	{
		id: 3,
		image: require("./images/desktop/image-gallery-cone.jpg"),
		name:"cone"
	},
	{
		id: 4,
		image: require("./images/desktop/image-gallery-sugarcubes.jpg"),
		name:"sugar cubes"
	},
]
